/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export enum ConvertOptionReturnCodes
{
    Success = 0,
    NoSelection = 1,
    NoFittingSupport = 2,
    ValidSelection = 3,
    Cancel = 4,
    ConduitTypeRequired = 5,
    CableTraySizeMismatch = 6,
    CableTrayTypeRequired = 7,
    IsWireMeshAndClearance=8,
    NoSelectionCt = 9,
    None = 10,
    Error = 11
}